<template>
  <div class="result">
    <div class="info-row">
      <b>团队名称：</b>
      <el-select
        v-model="teamId"
        size="medium"
        placeholder="请选择团队"
        @change="getList"
      >
        <el-option
          v-for="item in teamlist"
          :key="item.teamId"
          :label="item.name"
          :value="item.teamId"
        >
        </el-option>
      </el-select>
      <div class="captain">
        队长姓名：
        <span v-if="teamInfo">{{ teamInfo.captainName }}</span>
      </div>
    </div>

    <el-table :data="list" stripe class="list">
      <el-table-column prop="episode" label="集数" width="80" align="center">
      </el-table-column>
      <el-table-column prop="title" label="脚本名称"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="text"
            @click="handleCheck(row.waId, row.title)"
            >查看脚本</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="脚本列表" :visible.sync="show" width="80%" center>
      <p style="margin-bottom: 10px">
        所属文案名称: <b>{{ waName }}</b>
      </p>
      <el-table :data="sList" stripe class="list">
        <el-table-column type="index" label="序号" width="60" align="center">
        </el-table-column>
        <el-table-column prop="jb" label="景别" width="80" align="center">
        </el-table-column>
        <el-table-column prop="jd" label="角度" width="80" align="center">
        </el-table-column>
        <el-table-column prop="jtsc" label="镜头时长" width="80" align="center">
        </el-table-column>
        <el-table-column
          prop="pshm"
          label="拍摄画面"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="sy"
          label="声音"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="py" label="配乐" width="100" align="center">
        </el-table-column>
        <el-table-column
          prop="psdd"
          label="拍摄地点"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="dj" label="道具" width="100" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { teamList } from "@/api/team";
import { resultList, scenarioList } from "@/api/projectPractice/scenario";

export default {
  data() {
    return {
      teamId: null,
      teamlist: [],
      list: [],
      waName: "",
      sList: [],
      show: false,
    };
  },
  created() {
    this.getTeamList();
  },
  computed: {
    teamInfo() {
      return this.teamId
        ? this.teamlist.find((item) => item.teamId == this.teamId)
        : this.teamlist[0];
    },
  },
  methods: {
    // 团队列表
    getTeamList() {
      teamList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.teamlist = res.data;
          if (this.teamlist) this.teamId = this.teamlist[0].teamId;

          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 成果列表
    getList() {
      this.$loading.show();
      resultList({ teamId: this.teamId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 查看脚本
    handleCheck(waId, waName) {
      this.waName = waName;
      this.waId = waId;
      this.$loading.show();
      scenarioList(waId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.sList = res.data;
          this.show = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.result {
  .info-row {
    margin-bottom: 10px;
    text-align: left;
    line-height: 36px;
    overflow: hidden;
    .captain {
      float: right;
      font-weight: bold;
      span {
        color: teal;
      }
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>